export default "__VITE_ASSET__DUkjmzwE__"